import React from 'react';
import './PolicyPage.css';
import Footer from './Footer';
import ContactHome from './ContactHome';

const Abuse = () => {
  return (
    <div className="policy-page">
      <div className="policy-container">
        <h1>Abuse Policy</h1>
        <div className="policy-content">
          <section>
            <h2>1. Prohibited Activities</h2>
            <p>
              Fractallogy is committed to maintaining a safe and respectful environment for all users. 
              The following activities are strictly prohibited:
            </p>
            <ul>
              <li>Spam, phishing, or fraudulent activities</li>
              <li>Harassment, threats, or abusive behavior</li>
              <li>Distribution of malware or malicious code</li>
              <li>Unauthorized access or attempts to breach security</li>
              <li>Violation of intellectual property rights</li>
              <li>Any activity that violates applicable laws or regulations</li>
            </ul>
          </section>

          <section>
            <h2>2. Reporting Abuse</h2>
            <p>
              If you encounter any abusive behavior or content on our platform, please report it immediately. 
              You can report abuse by:
            </p>
            <ul>
              <li>
                <button 
                  className="policy-email-link"
                  onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
                >
                  Contacting us through our contact form
                </button>
              </li>
              <li>Using the report function within our platform</li>
              <li>Contacting our support team</li>
            </ul>
          </section>

          <section>
            <h2>3. Investigation Process</h2>
            <p>
              Upon receiving a report, we will:
            </p>
            <ul>
              <li>Review the reported content or behavior promptly</li>
              <li>Investigate the matter thoroughly</li>
              <li>Take appropriate action based on our findings</li>
              <li>Notify relevant parties as necessary</li>
            </ul>
          </section>

          <section>
            <h2>4. Enforcement Actions</h2>
            <p>
              Violations of this Abuse Policy may result in:
            </p>
            <ul>
              <li>Warning notices</li>
              <li>Temporary suspension of services</li>
              <li>Permanent termination of accounts</li>
              <li>Legal action when necessary</li>
              <li>Cooperation with law enforcement agencies</li>
            </ul>
          </section>

          <section>
            <h2>5. Content Moderation</h2>
            <p>
              We reserve the right to review, modify, or remove any content that violates our policies or 
              terms of service. We may do so without prior notice to protect our users and platform.
            </p>
          </section>

          <section>
            <h2>6. User Responsibilities</h2>
            <p>
              Users are responsible for:
            </p>
            <ul>
              <li>Ensuring their use of our services complies with this policy</li>
              <li>Reporting any abuse they encounter</li>
              <li>Cooperating with investigations when requested</li>
              <li>Maintaining the security of their accounts</li>
            </ul>
          </section>

          <section>
            <h2>7. Appeals Process</h2>
            <p>
              If you believe that action taken against your account was in error, you may appeal by{' '}
              <button 
                className="policy-email-link"
                onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
              >
                contacting us
              </button>. We will review your appeal and respond within a reasonable timeframe.
            </p>
          </section>

          <section>
            <h2>8. Updates to This Policy</h2>
            <p>
              We may update this Abuse Policy periodically to address new types of abuse or to clarify our 
              procedures. Continued use of our services after changes constitutes acceptance of the updated policy.
            </p>
          </section>

          <section>
            <h2>9. Contact Information</h2>
            <p>
              For questions about this Abuse Policy or to report abuse, please{' '}
              <button 
                className="policy-email-link"
                onClick={() => window.dispatchEvent(new CustomEvent('openContactForm'))}
              >
                contact us
              </button>.
            </p>
          </section>
        </div>
      </div>
      <ContactHome />
      <Footer />
    </div>
  );
};

export default Abuse;
